import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Link,
    Divider,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const OtherBranchDialog = ({
    branchDialogOpen,
    setBranchDialogOpen,
    otherBranch,
    vehicleDealerInfo
}: any) => {
    return (
        <Dialog
            open={branchDialogOpen}
            onClose={() => setBranchDialogOpen(false)}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: { borderRadius: 3, p: 2, position: "relative" }
            }}
        >
            {/* Close button (top-right) */}
            <IconButton
                size="small"
                sx={{ position: "absolute", top: 8, right: 8 }}
                onClick={() => setBranchDialogOpen(false)}
            >
                <CloseIcon />
            </IconButton>

            {/* Title */}
            <DialogTitle sx={{ fontWeight: 600, fontSize: '1.125rem', pb: 1 }}>
                {vehicleDealerInfo.dealerName}
            </DialogTitle>

            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {/* Address */}
                {vehicleDealerInfo.address && (
                    <Box display="flex" alignItems="center" gap={1}>
                        <LocationOnIcon fontSize="small" color="action" />
                        <Typography variant="body2" color="text.secondary">
                            {vehicleDealerInfo.address}
                        </Typography>
                    </Box>
                )}

                {/* Branch Count */}
                {otherBranch?.length > 0 && (
                    <Box display="flex" alignItems="center" gap={1}>
                        <StorefrontIcon fontSize="small" color="action" />
                        <Typography variant="body2" color="primary">
                            {otherBranch.length} more branch{otherBranch.length > 1 ? 'es' : ''}
                        </Typography>
                    </Box>
                )}

                {/* Other Branches with Dot */}
                {otherBranch?.length > 0 && (
                    <Box component="ul" sx={{ pl: 3, mb: 0 }}>
                        {otherBranch.map((branch: any, index: number) => (
                            <Box
                                key={index}
                                component="li"
                                sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}
                            >
                                <Box
                                    sx={{
                                        width: 6,
                                        height: 6,
                                        borderRadius: '50%',
                                        bgcolor: 'text.secondary',
                                        mt: '6px',
                                        mr: 1
                                    }}
                                />
                                <Typography variant="body2">
                                    <Link
                                        href={`https://maps.google.com/?q=${encodeURIComponent(branch.address || '')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        underline="hover"
                                        color="primary"
                                    >
                                        {branch.address} 
                                    </Link>
                                </Typography>
                                {/* {branch.contactNumber && (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <PhoneIcon fontSize="small" color="action" />
                                        <Typography variant="body2" color="text.secondary">
                                            {branch.contactNumber}
                                        </Typography>
                                    </Box>
                                )} */}
                            </Box>
                        ))}
                    </Box>
                )}

                {/* Contact */}
                {vehicleDealerInfo?.contactNumber && (
                    <Box display="flex" alignItems="center" gap={1}>
                        <PhoneIcon fontSize="small" color="action" />
                        <Link
                            href={`tel:${vehicleDealerInfo.contactNumber}`}
                            underline="hover"
                            color="primary"
                            variant="body2"
                        >
                            {vehicleDealerInfo.contactNumber}
                        </Link>
                    </Box>
                )}

                {/* Website */}
                {vehicleDealerInfo?.website && (
                    <Box display="flex" alignItems="center" gap={1}>
                        <LanguageIcon fontSize="small" color="action" />
                        <Link
                            href={vehicleDealerInfo.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            color="primary"
                            variant="body2"
                        >
                            {vehicleDealerInfo.website}
                        </Link>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default OtherBranchDialog;
